/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { IResourceProps } from 'apmui/resource/ResourceLoader';
import { RESOURCE } from 'apmui/resource/ResourceType';
import ResourceModel from 'apmui/resource/Model';

class OauthClientAppModel extends ResourceModel {
    //
    static readonly propNames = ['logo_url', ...ResourceModel.propNames];
    //
    type: RESOURCE.OAUTH_CLIENT_APP = RESOURCE.OAUTH_CLIENT_APP;
    logoImage: string;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);
        this.logoImage = resource.props.logo_url;
    }

    getPropNames(): string[] {
        return OauthClientAppModel.propNames;
    }
}

export { OauthClientAppModel as default, OauthClientAppModel };
